import {
  Palette, Code2, Search, Gauge, Smartphone, Server, MessageCircle,
  ClipboardList, MapPin, CalendarCheck, ShoppingBag, Newspaper, Languages,
  Wrench, Images, Lock, CreditCard, Layers, Sparkles, ShieldCheck, Rocket,
} from "lucide-react";

import workspaceImg from "../assets/images/sobre-nos.jpeg";

export const CONTACT = {
  phone: "+351 926 029 531",
  phoneHref: "tel:+351926029531",
  email: "getvisibledesign@gmail.com",
  emailHref: "mailto:getvisibledesign@gmail.com",
  instagram: "@getvisible_",
  instagramHref: "https://instagram.com/getvisible_",
  location: "Portugal",
};

export const NAV = [
  { label: "Início", to: "/" },
  { label: "Serviços", to: "/servicos" },
  { label: "Funcionalidades", to: "/funcionalidades" },
  { label: "Sobre Nós", to: "/sobre" },
  { label: "Contacto", to: "/contacto" },
];

// Serviços — 100% focados em websites.
export const MAIN_SERVICE = {
  title: "Design e desenvolvimento de websites à medida",
  body:
    "É isto que fazemos melhor. Criamos o seu website de raiz, pensado ao detalhe para o seu negócio — bonito, rápido e feito para converter visitantes em clientes.",
  points: [
    "Design 100% personalizado à sua marca",
    "Desenvolvimento próprio, sem templates genéricos",
    "Rápido, responsivo e otimizado para telemóvel",
    "Preparado para crescer o seu negócio",
  ],
};

export const SECONDARY_SERVICES = [
  {
    icon: Sparkles,
    title: "Branding",
    desc: "Precisa de logótipo ou de uma identidade visual? Criamos a imagem da sua marca para que tudo fique coerente com o website.",
  },
  {
    icon: Search,
    title: "SEO",
    desc: "Deixamos o seu website preparado para ser encontrado no Google, com as bases de SEO bem tratadas desde o início.",
  },
];

export const SERVICES = [
  { icon: Palette, title: "Design personalizado", desc: "Um visual único, desenhado à volta da sua marca e do seu público." },
  { icon: Code2, title: "Desenvolvimento", desc: "Websites feitos à medida, limpos por dentro e por fora." },
  { icon: Smartphone, title: "Totalmente responsivo", desc: "Perfeito no computador, tablet e telemóvel." },
  { icon: Gauge, title: "Otimização de velocidade", desc: "Páginas que carregam num instante — sem esperas." },
  { icon: Search, title: "SEO base", desc: "Estrutura pensada para ser encontrada no Google." },
  { icon: Server, title: "Domínio e alojamento", desc: "Tratamos de tudo: domínio, alojamento e configuração." },
  { icon: MessageCircle, title: "Integração WhatsApp", desc: "Botão direto para os clientes falarem consigo num toque." },
  { icon: ClipboardList, title: "Formulários", desc: "Contactos, pedidos e orçamentos a chegar ao seu email." },
  { icon: MapPin, title: "Google Maps", desc: "Mostre onde está e facilite a vida a quem o procura." },
  { icon: CalendarCheck, title: "Reservas online", desc: "Marcações e reservas diretamente no seu website." },
  { icon: ShoppingBag, title: "Lojas online", desc: "Venda os seus produtos 24 horas por dia, 7 dias por semana." },
  { icon: Newspaper, title: "Blog", desc: "Partilhe novidades e ganhe visibilidade no Google." },
  { icon: Languages, title: "Multilingue", desc: "Chegue a mais clientes em várias línguas." },
  { icon: Wrench, title: "Manutenção e atualizações", desc: "Ficamos por perto para manter tudo a funcionar." },
];

// Funcionalidades (substitui o Portfólio) — exemplos ilustrativos.
export const FEATURE_SHOWCASE = [
  {
    icon: ShoppingBag,
    title: "Lojas online",
    desc: "Venda os seus produtos com carrinho, pagamentos e gestão simples de stock.",
    image: "https://images.pexels.com/photos/4841737/pexels-photo-4841737.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1100",
    alt: "Exemplo ilustrativo de uma compra numa loja online com tablet e cartão",
  },
  {
    icon: CalendarCheck,
    title: "Reservas e marcações",
    desc: "Os seus clientes reservam ou marcam online, sem trocas de mensagens.",
    image: "https://images.unsplash.com/photo-1649433391719-2e784576d044?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100",
    alt: "Exemplo ilustrativo de um sistema de reservas com calendário",
  },
  {
    icon: MessageCircle,
    title: "Integração com WhatsApp",
    desc: "Um botão que liga o cliente diretamente à sua conversa de WhatsApp.",
    image: "https://images.pexels.com/photos/8939307/pexels-photo-8939307.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1100",
    alt: "Exemplo ilustrativo de um website de negócio local num portátil",
  },
];

export const FEATURES = [
  { icon: CalendarCheck, title: "Reservas online" },
  { icon: MessageCircle, title: "Integração WhatsApp" },
  { icon: ClipboardList, title: "Formulários inteligentes" },
  { icon: ShoppingBag, title: "Lojas online" },
  { icon: Images, title: "Galerias de imagens" },
  { icon: MapPin, title: "Google Maps" },
  { icon: Lock, title: "Áreas privadas" },
  { icon: CreditCard, title: "Pagamentos online" },
  { icon: Layers, title: "Várias páginas" },
  { icon: Newspaper, title: "Blog" },
  { icon: Languages, title: "Multilingue" },
  { icon: Sparkles, title: "Animações e efeitos" },
  { icon: Palette, title: "Design personalizado" },
  { icon: Search, title: "Otimização SEO" },
  { icon: Gauge, title: "Elevada velocidade" },
  { icon: Smartphone, title: "Para todos os dispositivos" },
];

export const COMPARISON = {
  old: {
    label: "Website antigo",
    items: ["Lento a carregar", "Difícil de utilizar", "Visual ultrapassado", "Não funciona no telemóvel", "Transmite pouca confiança"],
  },
  neu: {
    label: "Website Get Visible",
    items: ["Moderno e elegante", "Intuitivo e fácil de usar", "Rápido e otimizado", "Perfeito no telemóvel", "Pensado para gerar resultados"],
  },
};

export const PROCESS = [
  {
    n: "01",
    t: "Conhecemos o seu negócio",
    d: "Começamos por ouvir. Queremos perceber a sua empresa, os seus objetivos, o público-alvo e a identidade da sua marca.",
  },
  {
    n: "02",
    t: "Planeamos consigo",
    d: "Desenhamos uma proposta à sua medida e explicamos, de forma clara, todas as possibilidades antes de começar.",
  },
  {
    n: "03",
    t: "Criamos e melhoramos",
    d: "Desenvolvemos o website e sugerimos melhorias sempre que acreditamos que acrescentam valor. Mantemo-lo envolvido em cada passo.",
  },
  {
    n: "04",
    t: "Lançamento e acompanhamento",
    d: "Depois da sua aprovação, publicamos o website e garantimos que fica rápido, funcional e pronto para crescer.",
  },
];

export const VALUES = [
  {
    icon: Palette,
    title: "Feito à sua medida",
    body: "Cada negócio é diferente. Por isso, cada website também é. Adaptamos cores, tipografia, estrutura e funcionalidades à sua realidade — nunca a mesma solução para todos.",
  },
  {
    icon: Rocket,
    title: "Iniciativa e proatividade",
    body: "Não somos apenas executores. Sugerimos melhorias, antecipamos problemas e trazemos ideias — muitas vezes antes de as pedir. Tratamos o seu projeto como se fosse nosso.",
  },
  {
    icon: ShieldCheck,
    title: "Transparência total",
    body: "Sem surpresas. Explicamos tudo de forma simples, acompanhamo-lo do início ao fim e estamos por perto sempre que precisar.",
  },
];

export const IMAGES = {
  heroUI: "https://images.unsplash.com/photo-1634084462412-b54873c0a56d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  heroUIMobile: "https://images.unsplash.com/photo-1634084462412-b54873c0a56d?crop=entropy&cs=sRGB&fm=jpg&q=70&w=700",
  uiAlt: "https://images.unsplash.com/photo-1642132652860-471b4228023e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  phoneHand: "https://images.unsplash.com/photo-1691256676376-357c3aa66c89?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  workspace: workspaceImg,
  tabletBuy: "https://images.pexels.com/photos/4841737/pexels-photo-4841737.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
};
